// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"beb_a bii_wl","LoadingPlaceholder":"beb_b bii_h","loading-placeholder":"beb_c"};